import React, {
    Component
} from 'react';
import PropTypes from 'prop-types';
import './CreditDetails.less';

export default class CreditDetailsContainer extends Component {
    static propTypes = {
        children: PropTypes.node // CreditDetailsArticle
    };

    render() {
        return (
            <section className="CreditDetailsContainer">{this.props.children}</section>
        );
    }
}
